const MODULE_NAME = 'UtilitiesModule';

const utilities_set_search_text = `${MODULE_NAME}/SET_SEARCH_TEXT`;

export default utilities_set_search_text;
